// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  entryId: __t.u64().primaryKey().name("entry_id"),
  workspaceId: __t.u64().name("workspace_id"),
  roadId: __t.u64().name("road_id"),
  kind: __t.string(),
  summary: __t.string(),
  evidenceRefsJson: __t.string().name("evidence_refs_json"),
  supersededBy: __t.u64().name("superseded_by"),
  causedBy: __t.u64().name("caused_by"),
  atMicros: __t.i64().name("at_micros"),
});
